import type { Company } from '../../api/types';

// Which company and which page the app opens (unit-tested in app.test.ts).

const LAST_COMPANY_KEY = 'teamfolio.lastCompany';

export function rememberCompany(tenantId: string): void {
  try {
    localStorage.setItem(LAST_COMPANY_KEY, tenantId);
  } catch {
    // not remembered
  }
}

export function lastCompany(companies: Company[]): Company | undefined {
  let saved: string | null = null;
  try {
    saved = localStorage.getItem(LAST_COMPANY_KEY);
  } catch {
    saved = null;
  }
  return companies.find((company) => company.id === saved) ?? companies[0];
}

/** The company's landing page. Files used to be it; since the dashboard exists, this is. */
export const dashboardPath = (tenantId: string) => `/c/${tenantId}`;

/**
 * Whether I can open the company at all: not once it is suspended (TF-113) or deleted, and while its
 * deletion is scheduled only as an owner.
 */
export const canOpen = (company: Pick<Company, 'status' | 'role'>) => company.status === 'active' || (company.status === 'pending_deletion' && company.role === 'owner');

/**
 * The company the start page opens (TF-78): the one a link names; else the last used where I am a
 * member rather than a guest; else the last used (a guest everywhere). Never one I cannot open (TF-113).
 */
export function startCompany(companies: Company[], namedId: string | null): Company | undefined {
  const open = companies.filter(canOpen);
  return open.find((company) => company.id === namedId) ?? lastCompany(open.filter((company) => company.role !== 'external')) ?? lastCompany(open);
}

/** Where a company opens for me: its dashboard, or - for a guest, who has none - what is shared with me (TF-78). */
export const startPath = (company: Pick<Company, 'id' | 'role'>) => (company.role === 'external' ? '/shared' : dashboardPath(company.id));

export const filesPath = (tenantId: string, folderId?: string | null) => (folderId ? `/c/${tenantId}/files/${folderId}` : `/c/${tenantId}/files`);
